import { render, staticRenderFns } from "./exam-info.vue?vue&type=template&id=c33b7ec2&scoped=true"
import script from "./exam-info.vue?vue&type=script&lang=ts"
export * from "./exam-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33b7ec2",
  null
  
)

export default component.exports